import { useEffect, useState, useCallback } from 'react'
import { fetchLots } from '../api.js'

// Hook de listado de lotes con filtros/paginación.
// Devuelve: { data, pagination, loading, error, refetch }
// Acepta un objeto de parámetros (o null para no cargar).
export function useLots(params) {
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState(null)
  const [loading, setLoading] = useState(!!params)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    if (!params) { setLoading(false); return }
    setLoading(true)
    setError(null)
    try {
      const res = await fetchLots(params)
      setData(res.data || [])
      setPagination(res.pagination || null)
    } catch (e) {
      setError(e.message || 'Fehler beim Laden')
      setData([])
      setPagination(null)
    } finally {
      setLoading(false)
    }
  }, [JSON.stringify(params)]) // dependencia estable por serialización

  useEffect(() => { load() }, [load])

  return { data, pagination, loading, error, refetch: load }
}
